import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './ListEmployees.css';
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";

const ListEmployees = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/createemployee");
  }

  const [employees, setEmployees] = useState([]); // To store list of Employees
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [status, setStatus] = useState(''); // To store selected status value from dropdown
  const employeesPerPage = 10; // Number of Employees per page
  const axiosPrivate = useAxiosPrivate();
  const EMPLOYEES_URL = "api/list-employees"; // Replace with the correct API endpoint to fetch Employees
  const { auth } = useAuth();

  const handleViewClick = (employeeId) => {
    // Navigate to the GetFranchise component with employeeId as a URL parameter
    navigate(`/GetEmployee/${employeeId}`);
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const data1 = {
          franchise_id: auth.franchise_id,
          page: currentPage,
          per_page: employeesPerPage,
          status: status // Add status as part of the request
        };

        const response = await axiosPrivate.get(EMPLOYEES_URL, {
          params: data1,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });

        setEmployees(response.data); // Store the list of Employees into the state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching Employees:", error);
        setError("Failed to load Employees");
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchEmployees();
  }, [auth.franchise_id, currentPage, status]); // Adding 'status' to re-fetch data when it changes

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEditClick = (employee_id) => {
    navigate(`/UpdateEmployee/${employee_id}`);
  };
  // Total pages needed for pagination (this would ideally come from the API)
  const totalPages = Math.ceil(employees.length / employeesPerPage);

  // Handle dropdown value change
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  // Trigger search when clicking the search button
  const handleSearch = () => {
    setCurrentPage(1); // Reset to first page when searching
    // Fetch employees with the current status and page
  };

  const handleActivateEmployee = async (employee_id) => {
    try {
      const response = await axiosPrivate.post('api/activate-employee', {
        employee_id
      }, {
        withCredentials: true, // Include cookies if needed
      });

      if (response.status === 200) {
        alert("Employee activated successfully!");
        // Optionally, refresh the employee list after activation
        setEmployees((prev) => prev.map(emp =>
          emp.employee_id === employee_id ? { ...emp, status: 'Active' } : emp
        ));
      }
    } catch (error) {
      console.error("Error activating employee:", error);
      alert("Failed to activate employee.");
    }
  };
  const handleInactivateEmployee = async (employee_id) => {
    try {
      const response = await axiosPrivate.post('api/inactivate-employee', {
        employee_id
      }, {
        withCredentials: true, // Include cookies if needed
      });

      if (response.status === 200) {
        alert("Employee inactivated successfully!");
        // Optionally, refresh the employee list after activation
        setEmployees((prev) => prev.map(emp =>
          emp.employee_id === employee_id ? { ...emp, status: 'Inactive' } : emp
        ));
      }
    } catch (error) {
      console.error("Error inactiveting employee:", error);
      alert("Failed to inactivate employee.");
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (

    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Employee</button>

          <h3>Employees List</h3>

          {/* Dropdown for selecting employee status */}
          <div className="filter">
            <select value={status} onChange={handleStatusChange}>
              <option value="All">Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="All">All</option>
              {/* Add more options as needed */}
            </select>
            {/* <button onClick={handleSearch} className="btn btn-primary">Search</button> */}
          </div>

          {employees.length > 0 ? (
            <table id="customers">
              <thead>
                <tr>
                  <th>Employee ID</th>
                  <th>Employee Code</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                {employees.map((employee) => (
                  <tr key={employee.id}>
                    <td>{employee.employee_id}</td>
                    <td>{employee.employee_code}</td>
                    <td>{employee.name}</td>
                    <td>{employee.designation}</td>
                    <td>{employee.mobile1}</td>
                    <td>{employee.email}</td>
                    <td className="d-flex justify-content-start">
                      <button
                        type="button"
                        className="btn btn-primary btn-ico"
                        onClick={() => handleViewClick(employee.employee_id)}
                      >
                        <i className="bx bxs-show icon"></i>
                      </button>
                      <button type="button" className="btn btn-warning btn-ico ms-2" onClick={() => handleEditClick(employee.employee_id)}>
                        <i className="bx bxs-edit icon"></i>


                      </button>
                      {/* Activate Employee Button */}
                      {employee.status === 'Active' ? (
                        <button
                          type="button"
                          className="btn btn-outline-danger ms-2 btn-ico"
                          onClick={() => handleInactivateEmployee(employee.employee_id)}
                        >
                          Inactivate
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success ms-2 btn-ico"
                          onClick={() => handleActivateEmployee(employee.employee_id)}
                        >
                          Activate
                        </button>
                      )}

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No employees found</div>
          )}

          {/* Pagination - only show if there are multiple pages */}
          {totalPages > 1 && (
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}


        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListEmployees;
